import React from "react";
import { Button, TextField } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import logo from "@/assets/images/logo.png";
import styles from "./LoginForm.module.scss";

type EmailScreenProps = {
  onNext: (email: string) => void;
  errorMessage: string;
};

type FormValues = {
  email: string;
};

const EmailScreen = ({ onNext, errorMessage }: EmailScreenProps) => {
  const { control, handleSubmit } = useForm<FormValues>();

  const onSubmit = (data: FormValues) => {
    onNext(data.email);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img className={styles.logoImg} src={logo} alt="kid nation logo" />
        <p className={styles.text}>Login</p>
        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="email"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                label="Email"
                className={styles.input}
                placeholder="Your email address"
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#eff1f999",
                  },
                }}
                required
              />
            )}
          />
          {errorMessage && (
            <p className={styles.errorMessage}>{errorMessage}</p>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#000",
              color: "#fff",
              height: "58px",
              borderRadius: "12px",
              textTransform: "capitalize",
            }}
          >
            Next
          </Button>
        </form>
      </div>
    </div>
  );
};

export default EmailScreen;
